import { render, staticRenderFns } from "./RichTextItem.vue?vue&type=template&id=47fa2cc8&scoped=true&"
import script from "./RichTextItem.vue?vue&type=script&lang=js&"
export * from "./RichTextItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa2cc8",
  null
  
)

export default component.exports